export let mixin = () => {
    let state = {
        elements: document.querySelectorAll(`[data-type-it]`),
        isTyping: false,
        debounceScroll: false,
    };

    let module = {
        getVisibleElements() {
            return [...state.elements].filter((element) => {
                return this.isElementVisible(element) && !element.classList.contains('has-animated');
            });
        },
        doAnimation(elements) {
            let elIndex = 0;

            let animate = () => {
                if (elIndex >= elements.length) return;
                let element = elements[elIndex];
                if (element.classList.contains('has-animated')) {
                    elIndex++;
                    return animate();
                }

                state.isTyping = true;
                element.classList.add('has-animated');

                let delay = 0;
                let originalText = element.dataset.spaceholder;
                let textSlot = element.querySelector('span');
                let randomIncrement = (min, max) => Math.random() * (max - min) + min;

                originalText.split('').forEach((character, index) => {
                    setTimeout(() => {
                        textSlot.textContent += character;

                        if (index + 1 == originalText.length) {
                            elIndex++;
                            state.isTyping = false;
                            animate();
                        }
                    }, delay);

                    delay += randomIncrement(15, 40);
                });
            };
            animate();
        },
        debounceScroll() {
            state.debounceScroll = true;
            setTimeout(() => {
                state.debounceScroll = false;
            }, 50);
        },
        animateVisible() {
            // if (state.dounceScroll) return;
            // this.debounceScroll();
            if (state.isTyping) return;
            let elements = this.getVisibleElements();
            if (!elements.length) return;
            this.doAnimation(elements);
        },
        prepAnimation() {
            [...state.elements].map((element) => {
                let originalText = element.textContent;
                element.dataset.spaceholder = originalText;
                let textSlot = element.querySelector('span');
                textSlot.textContent = '';
            });
        },
        runAnimationLoop() {
            let callback = () => {
                this.animateVisible();
                requestAnimationFrame(callback);
            };
            callback();
        },
        init() {
            if (!state.elements.length) return;
            this.prepAnimation();
            this.runAnimationLoop();
        },
        //utils
        isElementVisible(el) {
            var rect = el.getBoundingClientRect(),
                vWidth = window.innerWidth || document.documentElement.clientWidth,
                vHeight = window.innerHeight || document.documentElement.clientHeight,
                efp = function (x, y) {
                    return document.elementFromPoint(x, y);
                };

            // Return false if it's not in the viewport
            if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) return false;

            // Return true if any of its four corners are visible
            return (
                el.contains(efp(rect.left, rect.top)) ||
                el.contains(efp(rect.right, rect.top)) ||
                el.contains(efp(rect.right, rect.bottom)) ||
                el.contains(efp(rect.left, rect.bottom))
            );
        },
    };

    return module.init();
};

export default {
    init() {
        return mixin();
    },
};
